import { SxProps, Theme } from "@mui/material/styles";


export const startNewRow: SxProps<Theme> = {
	gridColumnStart: 1
};

export const spanGridColumns: SxProps<Theme> = {
	gridColumn: "1 / -1"
};

